import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {CustomerInstanceGroupData, CustomerInstanceGroupSalesData} from "./customer-instance-group.data";
import {CustomerInstanceData} from "../customer-instance/customer-instance.data";
import {SubscriptionData} from "../customer-instance-venue/venue-plan/subscription.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class CustomerInstanceGroupService {

    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getCustomerInstanceGroup(id: string): Promise<CustomerInstanceGroupData> {
        return firstValueFrom(this.http.get<CustomerInstanceGroupData>("/fonzie/customer-instance-group/" + id, {headers: this.auth.getHttpHeaderOptions()}));

    }

    async createCustomerInstanceGroup(customerInstance: CustomerInstanceGroupData): Promise<CustomerInstanceGroupData> {
        return firstValueFrom(this.http.post<CustomerInstanceGroupData>("/fonzie/customer-instance-group", customerInstance, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async updateCustomerInstanceGroup(id: string, clientId: string): Promise<void> {
        return firstValueFrom(this.http.put<void>("/fonzie/customer-instance-group/" + id, {clientId: clientId}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstanceGroups(): Promise<CustomerInstanceGroupData[]> {
        return firstValueFrom(this.http.get<CustomerInstanceGroupData[]>("/fonzie/customer-instance-group", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstances(id: string): Promise<CustomerInstanceData[]> {
        return firstValueFrom(this.http.get<CustomerInstanceData[]>("/fonzie/customer-instance-group/" + id + "/instances", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstanceGroupSubscription(id: string): Promise<SubscriptionData> {
        return firstValueFrom(this.http.get<SubscriptionData>("/fonzie/customer-instance-group/" + id + "/subscription", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstanceGroupSales(id: string): Promise<CustomerInstanceGroupSalesData> {
        return firstValueFrom(this.http.get<CustomerInstanceGroupSalesData>("/fonzie/customer-instance-group/" + id + "/sales", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async assignInstanceGroupToCustomerInstance(instanceId: string, instanceGroupId: string): Promise<void> {
        return firstValueFrom(this.http.put<void>("/fonzie/customer-instance-group/" + instanceGroupId + "/assign-instance/" + instanceId, {}, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
